/* Bottom-right, so a toast never covers the primary button of a left-aligned form. */
.region {
  position: fixed;
  right: var(--space-5);
  bottom: var(--space-5);
  z-index: var(--z-toast);
  display: flex;
  flex-direction: column-reverse;
  gap: var(--space-2);
  outline: none;
}

.region[data-focus-visible] {
  outline: var(--focus-ring);
  outline-offset: var(--focus-offset);
}

.toast {
  display: flex;
  align-items: flex-start;
  gap: var(--space-4);
  min-width: 280px;
  max-width: 420px;
  padding: var(--space-3) var(--space-4);
  border-radius: var(--radius-float);
  background: var(--night);
  color: var(--on-brand);
  box-shadow: var(--shadow-float);
}

.toast[data-focus-visible] {
  outline: var(--focus-ring);
  outline-offset: var(--focus-offset);
}

.content {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: var(--space-1);
}

.title {
  font: var(--t-body-strong);
}

.description {
  font: var(--t-small);
}

.close {
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--on-brand);
  font: var(--t-small);
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
}

.close[data-focus-visible] {
  outline: 2px solid var(--on-brand);
  outline-offset: var(--focus-offset);
}

.close {
  min-height: var(--space-5);
}

/* Phones: full width at the bottom, inside the 16px gutters. */
@media (width < 640px) {
  .region {
    right: var(--gutter);
    bottom: var(--gutter);
    left: var(--gutter);
  }

  .toast {
    min-width: 0;
    max-width: none;
  }

  .close {
    min-height: var(--touch-target);
  }
}
